import HeaderTemplate from './HeaderTemplate';
import styled, { breakpoints } from '../../styles/theme';
import { rem } from 'polished';

const HeaderStyled = styled(HeaderTemplate)`
    background: ${({ theme }) => theme.colors.default};
    color: ${({ theme }) => theme.colors.white};
    padding: 0 ${rem('28px')};
    position: relative;
    .pxAttention {
        display: flex;
        align-items: center;
        justify-content: center;
        flex: none;
        width: ${rem('24px')};
        height: ${rem('24px')};
        border-radius: 50%;
        background-color: ${({ theme }) => theme.colors.lozenge};

        svg {
            height: ${rem('15px')};
        }
    }

    .header-container {
        display: flex;
        align-items: center;
        margin: 0;
        justify-content: space-between;
        width: auto;
        flex-grow: 1;
        max-width: none !important;
        padding: 0;

        .skip-content {
            position: absolute;
            width: 100%;
            display: flex;
            justify-content: center;
            top: 0;

            @media (max-width: ${breakpoints.sm}px) {
                display: none;
            }

            a {
                font-size: ${rem('10px')};
                background: ${({ theme }) => theme.colors.primary};
                color: ${({ theme }) => theme.colors.white};
                padding: ${rem('20px')};
                text-transform: uppercase;
                font-weight: bold;
                text-decoration: none;
                transform: translateY(-110%);
                transition: transform 0.2s ease-in-out, -webkit-transform 0.2s ease-in-out;

                &:focus-visible {
                    transform: translateY(0);
                    z-index: 9999999999;
                }
            }
        }

        @media (min-width: ${breakpoints.sm}px) {
            height: ${rem('80px')};
        }
    }

    .main-section {
        display: flex;
        max-height: 100%;
    }

    .header-logo-icon {
        width: ${rem(59)};
        height: ${rem(60)};

        @media (min-width: ${breakpoints.sm}px) {
            width: ${rem(55)};
            height: ${rem(60)};
        }
        svg {
            width: ${rem(59)};
            height: ${rem(60)};

            @media (min-width: ${breakpoints.sm}px) {
                width: ${rem(55)};
                height: ${rem(60)};
            }
        }
    }

    .title-section {
        padding: 0.5rem 1rem;
        margin-left: 1rem;
        border-left: 1px solid #ffffffaa;
        display: flex;
        flex-direction: column;
        justify-content: center;

        .title-primary {
            font-size: 1.5rem;
            line-height: 1.5rem;
            letter-spacing: 0.2rem;
            font-weight: 700;
            text-transform: uppercase;
            margin: 0;

            .pro-label-b2b {
                margin-left: ${rem(6)};
                color: ${({ theme }) => theme.colors.primary};
            }
        }

        .title-secondary {
            font-size: 1rem;
            line-height: 1rem;
            margin: 0.5rem 0 0 0;
            font-weight: 400;
        }
    }

    .link-section {
        display: none;
        align-items: flex-end;
        a {
            color: ${({ theme }) => theme.colors.primary};
            border-bottom: 0.3rem solid ${({ theme }) => theme.colors.primary};
            text-decoration: none;
            cursor: pointer;
            margin-right: 1.5rem;
            &:hover {
                color: ${({ theme }) => theme.colors.primaryHover};
                border-bottom: 0.3rem solid ${({ theme }) => theme.colors.primaryHover};
            }
        }

        @media (min-width: ${breakpoints.md}px) {
            display: flex;
        }
    }

    .logo {
        cursor: pointer;
        z-index: 9;
    }

    .center-logo-section {
        display: none;
    }

    .navigation {
        display: flex;
        align-items: center;
        position: relative;
        margin-top: ${rem(-10)};

        .need-help-open {
            @media (min-width: ${breakpoints.md}px) {
                background: ${({ theme }) => theme.colors.grey9};
                color: ${({ theme }) => theme.colors.grey1};

                svg {
                    g {
                        path {
                            fill: ${({ theme }) => theme.colors.grey1} !important;
                        }
                    }
                }
            }
        }

        a {
            background: none;
            cursor: pointer;
            border: none;
            color: #fff;
            margin-left: 0.8rem;
            height: 2.8rem;
            display: flex;
            flex-direction: column;
            align-items: center;
            text-decoration: none;

            &.need-help-link {
                padding: ${rem(4)};
                position: relative;

                .header__nav-description {
                    display: none;

                    @media (min-width: ${breakpoints.sm}px) {
                        display: initial;
                    }
                }

                .need-help-section__title {
                    white-space: initial;
                    font-size: ${({ theme }) => theme.fontSizes.h4};
                    margin: 0;
                }

                .header__nav-wrapper {
                    display: none;
                    padding: 0 ${rem(5)};

                    @media (min-width: ${breakpoints.md}px) {
                        display: block;
                    }
                }

                .need-help-icon {
                    margin: 0;

                    svg {
                        height: ${rem(24)};
                        width: ${rem(24)};
                    }
                }

                .icon-wrapper {
                    width: ${rem(24)};
                }

                svg {
                    g {
                        path {
                            fill: ${({ theme }) => theme.colors.white};
                        }
                    }
                }
            }

            p {
                margin: ${rem(5)} 0 0;
                text-transform: uppercase;
                font-size: ${({ theme }) => theme.fontSizes.textSmall};
                white-space: nowrap;
                text-decoration: none;

                @media (min-width: ${breakpoints.xs}px) {
                    font-size: ${rem(12)};
                }
            }

            @media (min-width: ${breakpoints.xs}px) {
                margin-left: 2rem;
            }
        }

        .need-help-section {
            position: fixed;
            z-index: 999999999999;
            top: ${rem(127)};
            width: 100%;

            &-left {
                left: 0;
            }

            &-right {
                right: 0;
            }

            @media (min-width: ${breakpoints.xs}px) {
                top: ${rem(100)};
            }

            @media (min-width: ${breakpoints.md}px) {
                position: absolute;
                top: 100%;
                width: ${rem(400)};
            }
        }

        .need-help-link__chevron {
            display: none;

            @media (min-width: ${breakpoints.md}px) {
                display: block;
            }
        }

        .logoutBox {
            position: absolute;
            top: calc(100% + 10px);
            right: ${rem('25px')};
            height: ${rem('100px')};
            width: ${rem('190px')};
            background: ${({ theme }) => theme.colors.white};
            box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.5);
            flex-direction: column;
            justify-content: flex-start;
            align-items: stretch;
            z-index: 9999999;
            display: none;
            &.is-open {
                display: flex;

                a {
                    &:focus-visible {
                        background: ${({ theme }) => theme.colors.primary};
                    }
                }
            }
            p {
                margin: 0;
                color: ${({ theme }) => theme.colors.black1};
            }
            .logoutButton {
                display: flex;
                justify-content: center;
                align-content: center;
                margin: 0 1rem;
                height: 2rem;
                border: 1px solid ${({ theme }) => theme.colors.grey10};
                color: ${({ theme }) => theme.colors.black1};
                transition: all 0.25s ease-out;

                :hover {
                    border: 1px solid ${({ theme }) => theme.colors.white};
                    background-color: ${({ theme }) => theme.colors.primary};
                    p {
                        color: ${({ theme }) => theme.colors.white};
                    }
                }
            }
            path {
                fill: ${({ theme }) => theme.colors.grey2};
            }
            .accountStatement {
                margin: 0 1rem 0.5rem;
                border-bottom: 1px solid ${({ theme }) => theme.colors.grey10};
                padding-bottom: 0.5rem;
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                height: unset;
                p {
                    margin: 5px 0 0 0.5rem;
                    text-transform: uppercase;
                }
                :hover {
                    p {
                        color: ${({ theme }) => theme.colors.secondaryHover};
                    }
                }
                .account {
                    margin: 0;
                }
            }

            ::before {
                content: '';
                align-self: center;
                border-left: 10px solid transparent;
                border-right: 10px solid transparent;
                border-bottom: 10px solid ${({ theme }) => theme.colors.white};
                position: relative;
                bottom: ${rem('10px')};
                right: ${rem('7px')};
            }
            @media (max-width: ${breakpoints.sm}px) {
                left: ${rem('-120px')};
                ::before {
                    left: ${rem('50px')};
                }
                .account {
                    path {
                        fill: ${({ theme }) => theme.colors.champagne1};
                    }
                }
                a {
                    p {
                        display: inline-block;
                    }
                }
            }
        }
    }

    .storeCar {
        height: ${rem(25)};
    }

    .b2b-switch {
        margin: 0;

        @media (max-width: ${breakpoints.xs}px) {
            display: none;
        }
    }

    .b2b-switch {
        position: relative;

        input {
            position: absolute;
            top: 0;
            z-index: 2;
            opacity: 0;
            cursor: pointer;

            &:checked {
                z-index: 1;
            }
        }

        button {
            width: ${rem(120)};
            height: ${rem(22)};
        }

        &:hover {
            .toggle-inside {
                background: ${({ theme }) => theme.colors.grey5};
                border-color: ${({ theme }) => theme.colors.grey5};
            }
        }
    }

    .b2b-switch input:checked {
        z-index: 1;
    }

    .b2b-switch input:checked + button {
        label {
            color: ${({ theme }) => theme.colors.blue2};
            font-weight: ${({ theme }) => theme.fontWeights.textBold};

            &:hover {
                color: ${({ theme }) => theme.colors.grey5};
            }
        }
    }

    .b2b-switch label {
        color: ${({ theme }) => theme.colors.grey1};
        cursor: pointer;
    }

    .b2b-switch .toggle-outside {
        height: 100%;
        border-radius: ${rem(17)};
        border: 2px solid ${({ theme }) => theme.colors.grey3};
        padding: ${rem(11)};
        transition: opacity 0.3s ease-in-out;
    }

    .b2b-switch .toggle-inside {
        border-radius: 50%;
        border: 2px solid ${({ theme }) => theme.colors.blue2};
        background: ${({ theme }) => theme.colors.blue2};
        position: absolute;
        transition: all 0.3s ease-in-out;
    }

    .switch-vertical {
        width: 0;
        height: ${rem(50)};
    }

    .switch-vertical input {
        height: 100%;
        width: ${rem(50)};
        right: 0;
        margin: 0;
    }

    .switch-vertical label {
        font-size: ${({ theme }) => theme.fontSizes.h4};
        line-height: ${rem(30)};
        width: ${rem(80)};
        height: 50%;
        padding-left: ${rem(10)};
        text-transform: capitalize;
        font-weight: ${({ theme }) => theme.fontWeights.textRegular};
        white-space: nowrap;
        letter-spacing: 0;
        display: flex;
        align-items: center;
    }

    .switch-vertical .toggle-outside {
        background: rgba(255, 255, 255, 0.5);
        position: absolute;
        width: ${rem(23)};
        height: 100%;
        right: 0;
        top: 0;
    }

    .switch-vertical .toggle-inside {
        height: ${rem(25)};
        left: -${rem(1)};
        top: -${rem(1)};
        width: ${rem(25)};
    }

    .switch-vertical input:checked ~ .toggle-outside .toggle-inside {
        top: -${rem(1)};
    }

    .switch-vertical input ~ input:checked ~ .toggle-outside .toggle-inside {
        top: ${rem(25)};
    }
`;

export default HeaderStyled;
